import styled from 'styled-components';

export const BalanceOnHandRouteContainerStyle = styled.div`
  .fkTuFL {
    max-height: 14em;
  }
  .generated-list {
    padding: 5px 0 !important;
  }

  .download-action-buttons {
    margin-top: -35px;
  }
`;
